import development from "./dev.config";
import stage from "./stage.config";
import production from "./prod.config";

export default {
  development,
  production,
  stage,
}[process.env.REACT_APP_ENV || "production"];
